import React from "react";
import Layout from "layouts";
import OneOffOrdersComponent from "./OneOffOrdersComponent";

export default function OneOffOrders() {
  return (
    <Layout breadCrumb={[{ label: "One-off Orders", to: "#" }]}>
      <OneOffOrdersComponent />
    </Layout>
  );
}
